module.exports = require("jsdom");


//////////////////
// WEBPACK FOOTER
// external "jsdom"
// module id = 9
// module chunks = 0